var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.erroMensagem)?_c('b-row',{staticClass:"mt-5 text-center"},[_c('b-col',[_c('img',{staticStyle:{"max-width":"90%"},attrs:{"src":_vm.logo}}),_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.erroMensagem))]),_c('b-button',{on:{"click":function($event){return _vm.retry()}}},[_vm._v("Tentar Novamente")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }